var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setActiveRpc } from '@popup/steem/actions/active-rpc.actions';
import { setDisplayChangeRpcPopup, setSwitchToRpc, } from '@popup/steem/actions/rpc-switcher';
import RpcUtils from '@popup/steem/utils/rpc.utils';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
import { store } from '@popup/multichain/store';
export const useWorkingRPC = (activeRpc) => __awaiter(void 0, void 0, void 0, function* () {
    const dispatch = store.dispatch; // Usa il tipo corretto
    const switchAuto = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.SWITCH_RPC_AUTO);
    const currentRpc = activeRpc || store.getState().steem.activeRpc;
    for (const rpc of RpcUtils.getFullList().filter((rpc) => rpc.uri !== (currentRpc === null || currentRpc === void 0 ? void 0 : currentRpc.uri) && !rpc.testnet)) {
        if (yield RpcUtils.checkRpcStatus(rpc.uri)) {
            if (switchAuto) {
                yield dispatch(setActiveRpc(rpc)); // Usa await per il thunk
            }
            else {
                dispatch(setSwitchToRpc(rpc));
                dispatch(setDisplayChangeRpcPopup(true));
            }
            return;
        }
    }
});
